import React from 'react';
import { Upload } from 'antd';
import {} from 'utils/utils.js';

const uploadProps = {
  listType: 'picture-card',
  showUploadList: {
    showRemoveIcon: false,
  },
};

export default class ReadOnlyFile extends React.Component {
  render() {
    const { url } = this.props;

    if (!url) {
      return '无';
    }

    return (
      <Upload
        {...uploadProps}
        fileList={[
          {
            uid: 1,
            url,
            thumbUrl: url,
          },
        ]}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/My/components/ReadOnlyFile.js